export default __webpack_public_path__ + "static/media/suitcase.24540e69.svg";